import gql from 'graphql-tag';
import { parseToMutationRequest } from '../../utils/utils';
import jobScheduleNS from './constants/jobScheduleNS';

export default data => {
  const dataRetry = parseToMutationRequest(data, jobScheduleNS);
  const retryJobSchedule = `retryJobSchedule(input: ${dataRetry})`;
  return gql`
  mutation {
    ${retryJobSchedule}{
      id
    }
  }
`;
};

// => change API processJobSchedule
// id
// status
// scheduleDate
// userId
// jobScheduleList {
//   index
//   jobId
//   predJobId
//   nextJobId
//   name
//   notes
//   userId
//   scheduleTime
//   type
//   scheduleType
//   status
//   count
//   countSuccess
//   countError
// }
// }
